import React from 'react';
import { useLocation } from 'react-router-dom';

function useHashParams() {
  const { hash } = useLocation();

  // hash 形如： "#error=xxx&error_code=yyy&error_description=zzz"
  return React.useMemo(() => {
    const raw = hash.startsWith('#') ? hash.slice(1) : hash;
    return new URLSearchParams(raw);
  }, [hash]);
}

function EmailConfirmResult() {
  const hashParams = useHashParams();

  const error =
    hashParams.get('error_description') ||
    hashParams.get('error') ||
    '';

  const hasError = !!error;

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      {hasError ? (
        <>
          <h1>邮箱验证失败</h1>
          <p style={{ marginTop: '12px', color: 'red' }}>
            {error || '验证链接无效或已过期，请重新请求验证邮件。'}
          </p>
          <p style={{ marginTop: '24px' }}>
            请返回应用或网站重新尝试。
          </p>
        </>
      ) : (
        <>
          <h1>邮箱验证成功</h1>
          <p style={{ marginTop: '12px' }}>
            您的邮箱已经完成验证，可以返回应用或网站继续使用。
          </p>
        </>
      )}
    </div>
  );
}

export default EmailConfirmResult;